import React from 'react'

export interface ValueFormat {
  /** Formats an amount in the feature's unit (pieces or euros). */
  format: (value: number) => string
  /** Same as `format`, with an explicit "+" for zero / positive values. */
  formatSigned: (value: number) => string
}

export function createValueFormat(format: (value: number) => string): ValueFormat {
  return {
    format,
    formatSigned: (value) => (value >= 0 ? `+${format(value)}` : format(value)),
  }
}

/**
 * Pieces (kpl), used by ilarit. Finnish number formatting like the euro amounts, e.g.
 * "4 000 kpl". Whole numbers have no decimals; decimals (if any were typed) are kept up to 2.
 */
export const piecesFormat = createValueFormat(
  (value) => `${value.toLocaleString('fi-FI', { maximumFractionDigits: 2 })} kpl`,
)

/**
 * Lets the editor's presentational children format amounts without prop drilling.
 * Defaults to pieces.
 */
export const ValueFormatContext = React.createContext<ValueFormat>(piecesFormat)

export const useValueFormat = (): ValueFormat => React.useContext(ValueFormatContext)
